export const variantPrice = (entry) =>
  entry.offer_enabled ? entry.offer_rate : entry.rate;

const productKey = (entry) => entry.item_id ?? entry.item_name;

export const groupMenuByProduct = (menu) => {
  const products = new Map();
  (menu ?? []).forEach((entry) => {
    const key = productKey(entry);
    if (!products.has(key)) {
      products.set(key, {
        key,
        item_id: entry.item_id ?? null,
        item_name: entry.item_name,
        variants: [],
      });
    }
    products.get(key).variants.push(entry);
  });

  return [...products.values()]
    .map((product) => ({
      ...product,
      variants: [...product.variants].sort((a, b) => variantPrice(a) - variantPrice(b)),
    }))
    .sort((a, b) => a.item_name.localeCompare(b.item_name));
};
